import type { AnnualStrategicDriver } from '../types/models';

// Work-item payloads carry `strategicDriverId` but never a nested driver, so
// every surface that names an item's driver looks it up here.
export function driversById(drivers: AnnualStrategicDriver[]): Map<string, AnnualStrategicDriver> {
  return new Map(drivers.map(d => [d.id, d]));
}

/** Driver progress for display: "—" when nothing is linked this year. */
export function formatProgress(progress: number | null | undefined): string {
  return progress == null ? '—' : `${Math.round(progress)}%`;
}

/** "12 of 40 done this year", or null when nothing counts yet. */
export function progressCounts(driver: Pick<AnnualStrategicDriver, 'progressDone' | 'progressTotal'>): string | null {
  const total = driver.progressTotal ?? 0;
  return total > 0 ? `${driver.progressDone ?? 0} of ${total} done this year` : null;
}
